export default __webpack_public_path__ + "static/media/CreteRound-Italic.4e7ace28.ttf";